import React from 'react';

const ComingSoon = () => {
    return (
        <div className="coming-soon-store" style={{ padding: '80px 20px', textAlign: 'center', backgroundColor: '#f8f9fa', minHeight: '60vh' }}>
            <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                <div style={{ fontSize: '4rem', marginBottom: '20px' }}>🛍️</div>
                <h1 style={{ fontSize: '3rem', marginBottom: '20px', color: '#1a1a1a' }}>CarVerse360 Shop</h1>
                <h2 style={{ fontSize: '1.5rem', color: '#007bff', fontWeight: 'normal', marginBottom: '40px' }}>Premium Accessories & Apparel for Fleet Owners</h2>
                <div style={{ borderTop: '2px solid #007bff', width: '60px', margin: '0 auto 40px auto' }}></div>
                
                <p style={{ fontSize: '1.2rem', color: '#666', lineHeight: '1.6', marginBottom: '40px' }}>
                    We are currently curating a high-performance selection of fleet management hardware, 
                    IoT tracking devices, and exclusive CarVerse360 apparel. 
                </p>

                <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)', display: 'inline-block' }}>
                    <h3 style={{ fontSize: '1.2rem', marginBottom: '15px' }}>Get Notified at Launch</h3>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <input type="email" placeholder="Enter your email" style={{ padding: '12px 20px', borderRadius: '6px', border: '1px solid #ddd', minWidth: '250px' }} />
                        <button style={{ padding: '12px 25px', backgroundColor: '#1a1a1a', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>Notify Me</button>
                    </div>
                </div>

                <div style={{ marginTop: '60px' }}>
                    <a href="/" style={{ color: '#666', textDecoration: 'none', fontWeight: 'bold' }}>&lative; Back to Fleet Software</a>
                </div>
            </div>
        </div>
    );
};

export default ComingSoon;
